export class SortLogsBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "SortLogsByFieldEnum",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortLogsBy.attributeTypeMap;
    }
    constructor() {
    }
}
export var SortLogsByFieldEnum;
(function (SortLogsByFieldEnum) {
    SortLogsByFieldEnum["Action"] = "action";
    SortLogsByFieldEnum["OperationName"] = "operationName";
    SortLogsByFieldEnum["RequestTime"] = "requestTime";
    SortLogsByFieldEnum["StatusCode"] = "statusCode";
    SortLogsByFieldEnum["InitiatorId"] = "initiatorId";
})(SortLogsByFieldEnum || (SortLogsByFieldEnum = {}));
